import 'simplelightbox/dist/simple-lightbox.jquery.min.js';

export default function lightbox() {
  $('.gallery a').simpleLightbox({ /* options */ });
}



// WEBPACK FOOTER //
// ./scripts/modules/lightbox.js